import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { sessionActions } from "../../state/ducks/session";

function InitSession({ getSession, setSessionToken, hasToken, children }) {
  useEffect(() => {
    if(hasToken) return;
    getSession();
  }, [getSession, setSessionToken]);

  return (
    <>
    { !hasToken ? null : children}
    </>
  );
}

function mapStateToProps(state) {
  return {
    hasToken: state.session.hasToken,
  };
}

const mapDispatchToProps = {
  ...sessionActions,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InitSession));